import { Component, type ReactNode, type ErrorInfo } from 'react'
import i18n from '../i18n'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}
interface State {
  hasError: boolean
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false }

  static getDerivedStateFromError(): State {
    return { hasError: true }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('ErrorBoundary caught:', error, info)
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div style={{ padding: '4rem 2rem', textAlign: 'center', color: '#2F3E35' }}>
            <h2 style={{ fontFamily: 'var(--font-serif-stack)', marginBottom: '1rem' }}>{i18n.t('common.errorOccurred')}</h2>
            <button
              onClick={() => this.setState({ hasError: false })}
              style={{
                padding: '0.7rem 1.6rem',
                border: '1px solid #77530a',
                borderRadius: '8px',
                background: 'transparent',
                color: '#77530a',
                cursor: 'pointer',
              }}
            >
              {i18n.t('common.tryAgain')}
            </button>
          </div>
        )
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
